import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'app-theme-chip-split',
	standalone: true,
	imports: [],
	template: `<svg [attr.width]="28" [attr.height]="28" viewBox="0 0 24 24" role="img">
		<circle cx="12" cy="12" r="11" [attr.fill]="backgroundColor()" />

		<defs>
			<clipPath id="rightHalf">
				<rect x="12" y="0" width="12" height="24"></rect>
			</clipPath>
		</defs>
		<circle cx="12" cy="12" r="11" [attr.fill]="color()" clip-path="url(#rightHalf)"></circle>

		<circle cx="12" cy="12" r="11" fill="none" stroke="black" stroke-width="1" />
	</svg> `,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeChipSplitComponent {
	readonly backgroundColor = input.required<string>();
	readonly color = input<string>();
}
